export const createSideEffects = effects => {
  return store => {
    store.subscribe((mutation, state) => {
      (effects[mutation.type] || noop)(store, mutation, state)
    })
  }
}

function noop () {}



// WEBPACK FOOTER //
// ./src/store/plugins.js